import React, { Suspense, lazy } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from '@components/Navigation';
import Footer from '@components/Footer';
import ToastContainer from '@components/ToastContainer';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('@pages/HomePage'));
const QuizPage = lazy(() => import('@pages/QuizPage'));
const DonationPage = lazy(() => import('@pages/DonationPage'));
const NotFound = lazy(() => import('@pages/NotFound'));

const App: React.FC = () => {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navigation />
        <main className="flex-grow">
          <Suspense fallback={
            <div className="flex items-center justify-center min-h-screen">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
                <p className="text-gray-600">Loading...</p>
              </div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/quiz" element={<QuizPage />} />
              <Route path="/donate" element={<DonationPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <ToastContainer />
      </div>
    </Router>
  );
};

export default App;
